import type { Messages } from "./es";

// Tono formal ("Sie") en toda la interfaz, como es habitual en hostelería
// alemana.
const de = {
  // ── Gemeinsam ──────────────────────────────────────────────────────
  commonPoweredBy: "Bereitgestellt von",
  commonManageReservationLink: "Meine Reservierung verwalten",
  commonRestaurantConfirmAvailability:
    "Das Restaurant bestätigt die Verfügbarkeit.",
  commonConnectionErrorShort: "Verbindungsfehler",
  commonConnectionErrorRetry: "Verbindungsfehler. Bitte versuchen Sie es erneut.",
  commonConnectionErrorLater:
    "Verbindungsfehler. Bitte versuchen Sie es später erneut.",
  commonPeopleOne: "{n} Person",
  commonPeopleOther: "{n} Personen",
  commonPeopleShortOne: "{n} Pers.",
  commonPeopleShortOther: "{n} Pers.",
  commonCalendarWeekdays: ["M", "D", "M", "D", "F", "S", "S"],
  commonTimeSuffix: " Uhr",

  commonMenuShowDescription: "Beschreibung anzeigen",
  commonMenuHideDescription: "Beschreibung ausblenden",
  commonMenuAllGuestsLabel: "Für den ganzen Tisch ({count} Personen)",
  commonMenuTotalLabel: "Ausgewählt: {total} von {count} Personen",
  commonMenuExceedsPartySize:
    "Das ausgewählte Menü übersteigt die Anzahl der Personen.",
  commonMenuSummaryItem: "{qty}× {name}",

  // ── App.tsx (Tischreservierung) ───────────────────────────────────────
  appOrgNotFoundHeading: "Restaurant nicht gefunden",
  appOrgNotFoundFallback: "Restaurant nicht gefunden",
  appOrgLoadNetworkError: "Fehler beim Laden der Restaurantdaten",
  appOrgLoadGenericError: "Die Restaurantdaten konnten nicht geladen werden",

  appSuccessHeadingLargeGroup: "Anfrage erhalten!",
  appSuccessHeadingPending: "Anfrage gesendet!",
  appSuccessHeadingConfirmed: "Reservierung bestätigt!",
  appSuccessBodyLargeGroup:
    "Ihre Gruppenanfrage bei {name} wurde registriert. Das Restaurant wird sich mit Ihnen in Verbindung setzen.",
  appSuccessBodyPending:
    "Ihre Reservierung bei {name} wartet auf Bestätigung. Wir informieren Sie, sobald das Restaurant sie bestätigt hat.",
  appSuccessBodyConfirmed: "Ihre Reservierung bei {name} wurde registriert.",
  appSuccessEmailNotePending:
    "Sie erhalten die Bestätigung an {email}",
  appSuccessEmailNoteConfirmed:
    "Sie erhalten eine Bestätigungs-E-Mail an {email}",
  appNewReservationButton: "Neue Reservierung vornehmen",

  appPartySizeLabel: "Anzahl der Personen",
  appLargeGroupButton: "Große Gruppe (+{threshold} Personen)",
  appLargeGroupQuestion: "Wie viele Personen sind Sie?",
  appLargeGroupPlaceholder: "z. B. 25",

  appSelectDayLabel: "Tag auswählen",
  appShowMoreDates: "Weitere Termine anzeigen",

  appSelectRoomLabel: "Bereich auswählen",
  appNoRoomsAvailable: "An diesem Tag ist kein Bereich verfügbar.",

  appSelectTimeLabel: "Uhrzeit auswählen",
  appDefaultClosedReason: "Ruhetag",
  appNoSlotsAvailable: "Keine Uhrzeiten verfügbar",
  appDefaultShiftLunch: "MITTAGESSEN",
  appDefaultShiftDinner: "ABENDESSEN",
  appNoTablesAvailable: "Keine Tische verfügbar",
  appContinueButton: "Weiter",

  appMenuQuestionHeading: "Möchten Sie ein Menü bestellen?",
  appMenuNoThanksButton: "Nein, danke",
  appMenuYesButton: "Ja",
  appMenuListHeading: "Wählen Sie Ihr Menü",
  appMenuSummaryHeading: "Ihr Menü:",

  appSummaryModify: "Ändern",
  appPhoneLabel: "Telefon *",
  appPhonePlaceholder: "0151 2345678",
  appNameLabel: "Vorname *",
  appNamePlaceholder: "Ihr Vorname",
  appLastNameLabel: "Nachname *",
  appLastNamePlaceholder: "Ihr Nachname",
  appEmailLabel: "E-Mail *",
  appEmailPlaceholder: "sie@email.com",
  appEmailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  appNotesLabel: "Anmerkungen (optional)",
  appNotesPlaceholderDefault:
    "Tischwünsche, Geburtstag, Kinderstuhl, eingeschränkte Mobilität usw.",

  appAcceptTermsPrefix: "Ich akzeptiere die",
  appTermsLinkLabel: "Allgemeinen Geschäftsbedingungen",
  appAcceptPrivacyPrefix: "Ich akzeptiere die",
  appPrivacyLinkLabel: "Datenschutzerklärung",
  appSpendNotice:
    "{restaurant} speichert den Rechnungsbetrag Ihrer Reservierung in Ihrem Kundenprofil. Sie können dem jederzeit widersprechen. Weitere Informationen:",
  appMarketingCheckbox: "Angebote und Neuigkeiten des Restaurants erhalten",

  appLargeGroupSummary: "Große Gruppe ({people})",

  appBackButton: "Zurück",
  appSubmitButton: "Reservieren",
  appSubmitting: "Wird gesendet...",
  appSubmitErrorFallback: "Fehler beim Erstellen der Reservierung",

  appFullCalendarTitle: "Datum auswählen",

  // ── ReservationManage.tsx (Reservierung über den Link verwalten) ─────
  manageLoading: "Ihre Reservierung wird geladen...",
  manageNotFoundHeading: "Reservierung nicht gefunden",
  manageFetchErrorFallback: "Reservierung nicht gefunden",
  manageConfirmErrorFallback: "Fehler bei der Bestätigung",
  manageCancelErrorFallback: "Fehler bei der Stornierung",
  manageModifyErrorFallback: "Fehler beim Ändern der Reservierung",

  statusPending: "Bestätigung ausstehend",
  statusConfirmed: "Bestätigt",
  statusCancelled: "Storniert",
  statusCompleted: "Abgeschlossen",
  statusNoShow: "Nicht erschienen",
  statusCancelledByEstablishment: "Vom Restaurant storniert",

  manageGoogleEventTitle: "Reservierung bei {name}",
  manageGoogleDetailsIntro: "Reservierung für {people}",
  manageGoogleDetailsCode: "Code: {code}",
  manageGoogleDetailsNotes: "Notizen: {notes}",

  manageConfirmSuccessHeading: "Reservierung bestätigt!",
  manageConfirmSuccessBody: "Wir erwarten Sie am {date} um {time}",
  manageAddToGoogleCalendar: "Zu Google Kalender hinzufügen",

  manageCancelSuccessHeading: "Reservierung storniert",
  manageCancelSuccessBodyLine1:
    "Ihre Reservierung wurde erfolgreich storniert.",
  manageCancelSuccessBodyLine2: "Wir hoffen, Sie bald wiederzusehen.",

  manageModifySuccessHeading: "Reservierung geändert",
  manageModifySuccessBodyLine1: "Ihre Änderungsanfrage wurde gesendet.",
  manageModifySuccessBodyLine2: "Sie erhalten in Kürze eine Bestätigung.",

  manageCancelledByRestaurantTitle:
    "Das Restaurant hat diese Reservierung storniert",
  manageCancelledByRestaurantBody:
    "Es tut uns leid für die Unannehmlichkeiten. Reservieren Sie gerne einen anderen Tag oder wenden Sie sich direkt an das Restaurant.",
  manageCancellationReasonLabel: "Vom Restaurant angegebener Grund",

  manageYourReservationHeading: "Ihre Reservierung",
  manageRoomLabel: "Bereich: {roomName}",
  manageCodeLabelBlock: "Reservierungscode",
  manageNotesLabel: "Notizen",

  manageMenuHeading: "Ihr Menü",
  manageMenuChangeButton: "Ändern",
  manageMenuNoneSelected: "Sie haben Ihrer Reservierung kein Menü hinzugefügt.",
  manageMenuNotEditableNotice:
    "Die Menüauswahl kann bis zum Vortag der Reservierung geändert werden.",
  manageMenuModalTitle: "Menü ändern",
  manageMenuSaveErrorFallback: "Fehler beim Speichern des Menüs",

  managePendingApprovalBannerTitle:
    "Warten auf Bestätigung durch das Restaurant.",
  managePendingApprovalBannerBody:
    "Sobald es bestätigt ist, erhalten Sie eine Benachrichtigung und können Ihre Teilnahme hier bestätigen.",
  manageConfirmDisabledTitle:
    "Verfügbar, sobald das Restaurant Ihre Anfrage bestätigt hat",
  manageConfirmDisabledLabel: "Teilnahme bestätigen (Bestätigung ausstehend)",
  manageConfirmButton: "Teilnahme bestätigen",

  managePendingChangeBannerTitle:
    "Sie haben bereits eine ausstehende Änderungsanfrage.",
  managePendingChangeBannerFooter:
    "Das Restaurant wird sie prüfen und Ihnen in Kürze antworten.",
  managePendingChangeDisabledTitle:
    "Sie haben bereits eine Änderungsanfrage, die noch geprüft wird",
  managePendingChangeDisabledLabel: "Änderungsanfrage ausstehend",
  manageModifyButton: "Reservierung ändern",
  manageCancelButton: "Reservierung stornieren",

  managePendingSummaryDate: "Datum: {date}",
  managePendingSummaryTime: "Uhrzeit: {time}",
  managePendingSummaryPeople: "Personen: {n}",

  manageWhatsAppButton: "Über WhatsApp kontaktieren",

  manageModalConfirmTitle: "Teilnahme bestätigen",
  manageModalConfirmQuestion:
    "Bestätigen Sie, dass Sie an Ihrer Reservierung bei {name} teilnehmen?",
  manageModalConfirmBack: "Zurück",
  manageModalConfirmSubmit: "Bestätigen",

  manageModalCancelTitle: "Reservierung stornieren",
  manageModalCancelWarningTitle: "Sind Sie sicher?",
  manageModalCancelWarningBody:
    "Dies kann nicht rückgängig gemacht werden. Wenn Sie stornieren, verlieren Sie Ihre Reservierung bei {name}.",
  manageModalCancelKeep: "Behalten",
  manageModalCancelSubmit: "Stornieren",

  manageModalEditTitle: "Reservierung ändern",
  manageModalEditDateLabel: "Datum",
  manageModalEditTimeLabel: "Uhrzeit",
  manageModalEditPartyLabel: "Anzahl der Personen",
  manageModalEditSummaryPrefix: "Neue Reservierung:",
  manageModalEditSummaryAt: "um",
  manageModalEditSummaryFor: "für",
  manageModalEditCancel: "Abbrechen",
  manageModalEditSubmit: "Änderungen speichern",

  // ── ConfirmReservation.tsx (Bestätigung über E-Mail/WhatsApp) ────────
  confirmLoading: "Ihre Reservierung wird bestätigt...",
  confirmErrorHeading: "Bestätigung nicht möglich",
  confirmAlreadyCancelled: "Diese Reservierung wurde bereits storniert.",
  confirmGenericErrorFallback: "Fehler beim Bestätigen der Reservierung",

  confirmAwaitingHeading: "Bestätigung ausstehend",
  confirmAwaitingBody:
    "Ihre Reservierung wartet auf die Bestätigung durch das Restaurant. Sobald sie bestätigt ist, erhalten Sie eine Benachrichtigung per E-Mail oder WhatsApp und können sie hier erneut bestätigen.",
  confirmCodeLabelInline: "Reservierungscode:",

  confirmAlreadyHeading: "Reservierung bereits bestätigt",
  confirmSuccessHeading: "Reservierung bestätigt!",
  confirmAlreadyBody: "Ihre Reservierung war bereits zuvor bestätigt.",
  confirmSuccessBody: "Vielen Dank für die Bestätigung Ihrer Teilnahme.",
  confirmFooterText: "Wir freuen uns auf Sie. Guten Appetit!",

  classesPickDay: "Tag auswählen",
  classesWeekPrev: "Vorherige Woche",
  classesWeekNext: "Nächste Woche",
  classesCountOne: "{n} Kurs",
  classesCountOther: "{n} Kurse",
  classesNoClassesThisDay: "An diesem Tag keine Kurse",
  classesSeatsLeft: "{n} von {total} Plätzen frei",
  classesFull: "Ausgebucht",
  classesMinutes: "{n} Min.",
  classesTeacher: "Lehrer: {name}",
  classesPeople: "Personen",
  classesName: "Vor- und Nachname",
  classesEmail: "E-Mail",
  classesPhone: "Telefon (optional)",
  classesMarketing: "Ich möchte Neuigkeiten von diesem Unternehmen erhalten",
  classesSubmit: "Buchung bestätigen",
  classesSubmitting: "Wird gebucht…",
  classesFieldsError: "Bitte Name und E-Mail prüfen",
  classesOnlyLeft: "Nur noch {n} freie Plätze in diesem Kurs",
  classesFullNow:
    "Dieser Kurs ist gerade voll geworden. Bitte andere Zeit oder anderen Tag wählen.",
  classesSuccessTitle: "Buchung bestätigt!",
  classesSuccessCode: "Buchungscode",
  classesSuccessEmailSent:
    "Wir haben dir eine E-Mail mit den Details und dem Link zur Verwaltung deiner Buchung geschickt.",
  classesNewBooking: "Weitere Buchung",
  classesLoadError:
    "Informationen konnten nicht geladen werden. Bitte erneut versuchen.",
  classesCompanyToggle:
    "Ich buche im Auftrag eines Unternehmens (Hotel, Agentur…)",
  classesCompanyName: "Name des Unternehmens oder Hotels",
} satisfies Messages;

export default de;
